export type ExchangeRates = {
  usd: number;
  gel: number;
  rub: number;
  fetchedAt: string | null;
};

const FALLBACK: ExchangeRates = { usd: 1, gel: 2.72, rub: 85, fetchedAt: null };

export function useExchangeRates() {
  const result = useFetch<ExchangeRates>('/api/exchange-rates', {
    key: 'exchange-rates',
    default: () => FALLBACK,
  });

  // /admin сидит за <AdminTokenGate> внутри <ClientOnly>: SSR его не рендерит,
  // карточка монтируется уже после гидрации, и useFetch в этой фазе не делает
  // auto-execute — data залипает на FALLBACK (2.72/85). Дёргаем refresh()
  // вручную, если payload пуст (fetchedAt === null). На публичных страницах
  // SSR успевает наполнить payload реальными числами, и условие пропускает.
  if (import.meta.client) {
    onMounted(() => {
      if (result.data.value?.fetchedAt == null) result.refresh();
    });
  }

  return result;
}
